export default __webpack_public_path__ + "static/media/Graph.0fa722c4.png";